import * as angular from "angular";

export class LabelsRequestsService {

  /* @ngInject */
  constructor(private LabelsAPI, private $labels) {
  }

  getAll() {
    const api = this.LabelsAPI.actions.getAll;
    return this.$$call(api, {}, {}, {});
  }

  createOne(label) {
    const api = this.LabelsAPI.actions.createOne;
    return this.$$call(api, {}, label, {});
  }

  updateOne(label) {
    const api = this.LabelsAPI.actions.updateOne;
    return this.$$call(api, {}, label, {id: label.id});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$labels().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.labels')
  .service('labelsRequestsService', LabelsRequestsService);
